<template>
  <div>
    <app-header />
    <layout />
    <app-footer />
    <loading-modal />

    <portal-target
      name="app-end"
      multiple
    />
  </div>
</template>

<script>
import Header from '../components/Header';
import Layout from '../layouts/Layout';
import Footer from '../components/Footer';
import LoadingModal from "../components/LoadingModal";

export default {
  name: "App",
  components:{
    Header,
    Layout,
    Footer,
    LoadingModal
  }
}
</script>

<style scoped>

</style>
